import { Routes, Route } from 'react-router-dom'
import { SaaS } from '../features/client/saas_payment'

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<div />} />
      <Route path="/pay" element={<SaaS />} />
    </Routes>
  )
}

export default Routing
